<template>
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">
                <span class="mdi mdi-history text-muted"></span> Recent Tests
            </h5>

            <div v-if="recentTests && recentTests.length > 0 && viewState != 'Busy'">
                <b-table ref="testDataTable"
                    striped hover small
                    selectable
                    select-mode="single"
                    class="mt-3"
                    @row-selected="onRowSelected"
                    :items="recentTests"
                    :fields="fields">
                    <template v-slot:cell(_vehicle)="data">                                
                        <span>{{ data.item.vehicle.manufacturer }} {{ data.item.vehicle.model }}</span>
                    </template>
                    <template v-slot:cell(_result)="data">
                        <div>
                            <span v-if="data.item.test_passed"><strong class="text-success">PASS</strong></span>
                            <span v-if="!data.item.test_passed"><strong class="text-danger">FAIL</strong></span>
                        </div>
                    </template>
                </b-table>
            </div>

            <div class="mt-5 pb-4" v-if="(!recentTests || recentTests.length == 0) && viewState == 'Idle'">
                <div class="text-center">
                    <h5 class="text-muted mb-3">No recent tests</h5>
                </div>
            </div>  

            <!-- Loading info -->
            <div class="d-flex d-flex justify-content-center mt-5 mb-5" v-if="viewState == 'Busy'">
                <b-spinner variant="secondary" style="width: 1.8rem; height: 1.8rem;"></b-spinner>
            </div>
            <!-- /Loading info -->

            <!-- Error state -->
            <div v-if="viewState == 'Error'">
                <div class="alert alert-danger mt-3">
                    Something went wrong loading your test data, please try again. 
                    If the problem persists, please contact our support team.
                </div>
            </div>
            <!-- /Error state -->
        </div>
    </div>
</template>

<script>
    import { TestService } from '../services/testService'

    export default {
        data() {
            return {
                viewState: 'Idle',
                recentTests: [],
                fields: [
                    { key: 'time_start', label: 'Date Tested', formatter: (dt) => { return this.$moment(dt).format('DD/MM/YYYY HH:mm') } },
                    { key: 'location_name', label: 'Location' },
                    { key: 'test_type', label: 'Test Type' },
                    { key: 'vehicle.registration', label: 'Vehicle Reg.'},
                    { key: '_vehicle', label: 'Make/Model' },
                    //{ key: '_result', label: 'Result' }
                ]
            }
        },
        async mounted() {
            this.viewState = 'Busy'
            try {
                let pagedResult = await TestService.getVehicleTestsPaged()
                this.recentTests = pagedResult.data
                console.log(this.recentTests)
                this.viewState = 'Idle'
            } catch (error) {
                this.viewState = 'Error'
                console.error(error)
            }
        },
        methods: {            
            onRowSelected(items) {
                if (items.length > 0) {
                    this.$router.push({
                        name: 'test-details',
                        params: {
                            testId: items[0].test_id
                        }
                    })
                }
                this.$refs.testDataTable.clearSelected()
            }
        }
    }
</script>